import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import Navbar from "../../../components/comm/Navbar";
import Header from "../../../components/comm/Head";
import style from './Alarm.module.css';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';
import { getCommCdList } from '../../../assets/js/comm';

import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

import noDataImg from '../../../images/common/i_3d_no_data_doc.svg';
import { useNavigate } from 'react-router-dom';

// 공통 알림 리스트 컴포넌트
const NotificationListComponent = ({ notifications, onItemClick, showIm, loading }) => {

  // 중요 알림인지 확인하는 함수 - imprtAt 필드 기반으로 변경
  const isImportantNotification = (item) => {
    console.log('imprtAt 값:', item.imprtAt, typeof item.imprtAt); // 디버깅용
    return String(item.imprtAt) === "1";
  };

  return (
    <div className={style['alarm-list-box']}>
      <div className='list-wrap' data-style='2'>
        <ul>
          {notifications.length > 0 ? (
            notifications.map((item, index) => (
              <li onClick={() => onItemClick(item)} key={index}>
                <div className='list-inner-box no-check'>
                  <div className='txt-box'>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div className={`txt-box ${(isImportantNotification(item)) ? 'hit' : ''}`}>
                        <span className='top-tit'>
                          {item?.alrmSj}
                        </span>
                        {/* <span>{JSON.stringify((isImportantNotification(item)))}</span> */}
                      </div>
                    </div>
                    <strong className={item?.alrmTyCd === 'PA05' ? style['no-ellipsis'] : ''}>
                      {item?.alrmCn?.replace(/<[^>]*>?/gm, '').replace(/&[a-zA-Z0-9#]+;/g, ' ')}
                    </strong>
                    <p>
                      {item?.sndrDeptNm ?
                        <>
                          <span>{item?.cnncHsptlNm}</span>
                          <span>{item?.sndrDeptNm}</span>
                        </>
                        : <></>
                      }
                    </p>
                    <span className='date'>{item?.sentAt?.replace('T', ' ')}</span>
                  </div>
                  <span className='more-btn'></span>
                </div>
              </li>
            ))
          ) : (
            <li>
              <div className={style['no-data-box']}>
                <div className={style['img-box']}>
                  <object data={noDataImg} aria-hidden='true'></object>
                </div>
                <p>알림이 없습니다.</p>
              </div>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};


const Alarm = () => {

  const navigate = useNavigate();


  const EXCLUDED_TYPES = ['']; // 알람 리스트 타입 제외 필터
  // const EXCLUDED_TYPES = [];


  const [value, setValue] = React.useState('1');
  const [notificationList, setNotifications] = useState([]);

  // 페이징 상태 관리
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  // 스위치 상태 관리
  const [filters, setFilters] = useState({
    unread: false,     // 기본값 false로 변경
    important: false,  // 기본값 false로 변경
    today: false       // 기본값 false로 변경
  });

  const [isInitialLoading, setIsInitialLoading] = useState(true);

  // 탭 설정 (라벨, 알림 타입, 중요도 매핑)
  const TAB_CONFIG = [

    // 251023_bak
    // { value: '1', label: '전체', alarmType: 'ALL', isImportant: false },
    // { value: '2', label: '오늘 할일', alarmType: 'PA06', isImportant: true },
    // { value: '3', label: '재택 치료 가이드', alarmType: 'PA07', isImportant: true },
    // { value: '4', label: '맞춤 질환 정보', alarmType: 'PA08', isImportant: true },
    // { value: '5', label: '추천 정보', alarmType: 'PA09', isImportant: false }

    { value: '1', label: '전체', alarmType: 'ALL', isImportant: false },
    { value: '2', label: '오늘 할 일', alarmType: 'PA06', isImportant: true },
    { value: '3', label: '진료 일정', alarmType: 'PA01', isImportant: true },
    { value: '4', label: '재택 치료 가이드', alarmType: 'PA07', isImportant: true },
    { value: '5', label: '추천 정보', alarmType: 'PA09', isImportant: false },
    { value: '6', label: '공지/안내', alarmType: 'PA05', isImportant: true },

  ];

  // 화면초기화렌더 useRef 선언
  const isInitialRender = useRef(true);

  //  스켈레톤 리스트 추가
  const renderSkeletons = () => {
    return Array.from({ length: 5 }).map((_, index) => (
      <li key={`skeleton-${index}`}>
        <div className='list-inner-box no-check'>
          <div className='txt-box'>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Skeleton variant="text" width="70%" height={24} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="40%" height={18} />
            </Box>
          </div>
        </div>
      </li>
    ));
  };

  useEffect(() => {

    if (isInitialRender.current) {
      getCommCdAlrm();
      resetAndLoadNotifications();
      isInitialRender.current = false;
    }
  }, []);

  // 필터나 탭 변경시 초기화 후 재로드
  useEffect(() => {
    resetAndLoadNotifications();
  }, [filters, value]);

  // 무한 스크롤 감지
  useEffect(() => {
    const handleScroll = () => {
      if (loading || !hasMore) return;

      // 더 정확한 스크롤 하단 감지
      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight;

      // 스크롤이 하단 100px 이내에 도달했을 때만 로드
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        loadMoreNotifications();
      }
    };

    // throttle 적용하여 너무 자주 호출되지 않도록
    let timeout;
    const throttledScroll = () => {
      if (timeout) return;
      timeout = setTimeout(() => {
        handleScroll();
        timeout = null;
      }, 200);
    };

    window.addEventListener('scroll', throttledScroll);
    return () => {
      window.removeEventListener('scroll', throttledScroll);
      if (timeout) clearTimeout(timeout);
    };
  }, [loading, hasMore, page]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // 스위치 상태 변경 핸들러
  const handleFilterChange = (filterType) => (event) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: event.target.checked
    }));
  };

  // 오늘 날짜인지 확인하는 함수
  const isToday = (dateString) => {
    if (!dateString) return false;

    const today = new Date();
    const targetDate = new Date(dateString);

    return today.getFullYear() === targetDate.getFullYear() &&
      today.getMonth() === targetDate.getMonth() &&
      today.getDate() === targetDate.getDate();
  };

  const getCommCdAlrm = async () => {
    // let r = await getCommCdList('PUSH_ALARM_CD');
    // console.log('r : ', r);
  }

  // 탭별 알림 리스트 필터링 및 정렬

  const getFilteredNotificationsByTab = (tabValue) => {
    let filtered = [...notificationList];

    const currentTab = TAB_CONFIG.find(tab => tab.value === tabValue);
    const alarmType = currentTab?.alarmType;

    if (alarmType && alarmType !== 'ALL') {
      filtered = filtered.filter(item => item.alrmTyCd === alarmType);
    }

    if (filters.unread) {
      filtered = filtered.filter(item => !item.readYn || item.readYn === '0');
    }

    if (filters.important) {
      filtered = filtered.filter(item => String(item.imprtAt) === "1");
    }

    if (filters.today) {
      filtered = filtered.filter(item => isToday(item.sentAt));
    }

    filtered.sort((a, b) => new Date(b.frstRgstDt) - new Date(a.frstRgstDt));

    return filtered;
  };

  // 알림 아이템 클릭 핸들러
  const handleNotificationClick = async (item) => {
    const { alrmTyCd, alrmTmplatId, id, cnncPrmtrVal } = item;
    const jToken = localStorage.getItem("jToken");

    // 모든 알림 클릭 시 읽음 처리 먼저
    if (!item.readYn || item.readYn === '0') {
      try {
        await axiosApi.post("/notifications/medication-read", { id }, {
          headers: { "Authorization": `Bearer ${jToken}` }
        });
        setNotifications(prev =>
          prev.map(n => n.id === id ? { ...n, readYn: '1' } : n)
        );
      } catch (err) {
        console.error("알림 읽음 처리 실패", err);
      }
    }

    // 이후 라우팅
    switch (alrmTyCd) {
      case 'PA061':
        if (alrmTmplatId === '10' && cnncPrmtrVal) {
          try {
            const paramData = JSON.parse(cnncPrmtrVal);
            navigate('/RecordSettingDetail', {
              state: {
                paramData,
                item: {
                  hsptlCd: paramData.hsptlCd,
                  patntId: paramData.patntId,
                  deptCd: paramData.deptCd,
                  prscrptnDt: paramData.prscrptnDt
                }
              }
            });
          } catch (e) {
            console.error("cnncPrmtrVal 파싱 실패", e);
          }
        }
        break;

      case 'PA062':
        navigate('/HomeCareMain', {
          state: { tab: 'health-record', notification: item },
          replace: true
        });
        break;

      case 'PA01':
        break;

      case 'PA07':
        navigate('/HomeCareMain?tab=2', { replace: true });
        break;

      case 'PA08':
        navigate('/HomeCareMain?tab=3', { replace: true });
        break;

      case 'PA05':
        break;

      case 'PA052':
        break;

      case 'PA053':
        break;

      case 'PA054':
        break;

      case 'PA09':
        navigate('/HomeCareMain?tab=3', { replace: true });
        break;

      default:
        console.log('알 수 없는 알림 타입:', alrmTyCd);
        break;
    }
  };

  const resetAndLoadNotifications = () => {
    setNotifications([]);
    setPage(0);
    setHasMore(true);
    setLoading(false);
    setTimeout(() => getNotificationsList(0, true), 100);
  };

  // 더 많은 알림 로드
  const loadMoreNotifications = () => {
    if (!loading && hasMore) {
      getNotificationsList(page + 1, false);
    }
  };

  const getNotificationsList = async (pageNum = 0, isReset = false) => {
    if (loading) return;

    setLoading(true);

    const url = "/notifications/list";
    const jToken = localStorage.getItem('jToken');
    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    console.log(loginUser?.usrInfoId);

    const reqOptions = {
      headers: {
        Authorization: `Bearer ${jToken}`,
      }
      , withCredentials: true
    };

    const reqBody = {
      "usrInfoId": loginUser?.usrInfoId,
      "page": pageNum,
      "size": 20
    };

    try {
      const res = await axiosApi.post(url, reqBody, reqOptions);

      if (res.data.resultCode === CODE.RCV_SUCCESS) {
        // const newNotifications = res.data.result.notifications;

        // const newNotifications = res.data.result.notifications.filter(
        //     item => !EXCLUDED_TYPES.includes(item.alrmTyCd) || item.alrmTmplatId === '10'
        // );

        const newNotifications = res.data.result.notifications.filter(item => {
          const isBasicAllowed = !EXCLUDED_TYPES.includes(item.alrmTyCd) || item.alrmTmplatId === '10';

          const isExcludedTarget = (item.alrmTmplatId === '14' && item.alrmTyCd === 'PA061');

          return isBasicAllowed && !isExcludedTarget;
        });

        console.log('새로운 알림:', newNotifications);

        // 데이터가 20개 미만이면 마지막 페이지
        if (newNotifications.length < 20) {
          setHasMore(false);
        }

        if (isReset) {
          setNotifications(newNotifications);
        } else {
          setNotifications(prev => [...prev, ...newNotifications]);
        }

        setPage(pageNum);
      }
    } catch (err) {
      console.error("notifications list : ", err);
    } finally {
      setLoading(false);
      setIsInitialLoading(false);
    }
  }

  /*
   푸시 알림 토큰 업데이트 (우리 자체 DB)
   */
  const notificationsSendTest = async () => {
    const now = new Date();

    const formatted = now.getFullYear() + '-' +
      String(now.getMonth() + 1).padStart(2, '0') + '-' +
      String(now.getDate()).padStart(2, '0') + '-' +
      String(now.getHours()).padStart(2, '0') + ':' +
      String(now.getMinutes()).padStart(2, '0') + ':' +
      String(now.getSeconds()).padStart(2, '0');


    const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

    const jToken = localStorage.getItem("jToken");

    const url = "/notifications/sendTest";

    const reqBody = {
      "pushList": [
        {
          "apiKey": "DE3Dm711QtynYjOVc34-tQ",
          "uid": loginUser?.usrUid,
          "custId": `test_${formatted}`,
          "title": `test msg`,
          "body": `test msg`,
          "sendType": 1,
          "data": {
          }
        }
      ]
    }

    const reqOptions = {
      headers: {
        'Authorization': 'Bearer ' + jToken,
      }
    };

    try {
      const res = await axiosApi.post(url, reqBody, reqOptions);

      if (res.data.resultCode === CODE.RCV_SUCCESS) {
        alert('테스트 발송 완료: ' + res.data.result.pushResult);
      } else {

      }
    } catch (err) {
      console.error("notifications/sendTest err", err);
      return false;
    }
  };

  return (
    <><div onClick={notificationsSendTest} style={{ color: 'black', position: 'absolute', top: 15, left: 100, zIndex: 500, opacity: 0 }}>123123123</div>
      <Header menu="alarm" />

      <div className="container" data-posi='fixed'>

        <TabContext value={value} className="tab-context">
          <div className='top-tab-head' data-posi='fixed'>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="scrollable"
              scrollButtons={false}
              className={style["tab-lists"]}
            >
              {TAB_CONFIG.map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  disableRipple
                />
              ))}
            </TabList>
          </div>
          {/* 스위치 버튼::S */}
          <div className={style['swich-btn-box']}>
            <ul>
              <li>
                <div className='swich-btn'>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={filters.unread}
                        onChange={handleFilterChange('unread')}
                        size="small"
                      />
                    }
                    label="미확인 알림"
                  />
                </div>
              </li>
              {/* 추천정보 탭(value='5')에서는 중요 알림 스위치 숨김 */}
              {value !== '5' && (
                <li>
                  <div className='swich-btn'>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={filters.important}
                          onChange={handleFilterChange('important')}
                          size="small"
                        />
                      }
                      label="중요 알림"
                    />
                  </div>
                </li>
              )}
              <li>
                <div className='swich-btn'>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={filters.today}
                        onChange={handleFilterChange('today')}
                        size="small"
                      />
                    }
                    label="오늘 온 알림"
                  />
                </div>
              </li>
            </ul>
          </div>
          {/* 스위치 버튼::E */}

          {/* 동적 탭 패널 생성 */}
          {TAB_CONFIG.map((tab) => (
            <TabPanel key={tab.value} value={tab.value}>
              {isInitialLoading ? (
                // 첫 로딩일 때만 스켈레톤 표시
                <div className={style['alarm-list-box']}>
                  <div className='list-wrap' data-style='2'>
                    <ul>{renderSkeletons()}</ul>
                  </div>
                </div>
              ) : (
                <NotificationListComponent
                  notifications={getFilteredNotificationsByTab(tab.value)}
                  onItemClick={handleNotificationClick}
                  loading={loading}
                  hasMore={hasMore}
                />
              )}
            </TabPanel>
          ))}

        </TabContext>
      </div>

      <Navbar />
    </>
  )
}

export default Alarm;
